import * as z from 'zod';

import { NonNegativeFloat, NonNegativePercentage } from '../../fields';

export const RemittanceFields = z.object({
  investorRemittanceRate: NonNegativeFloat.optional().meta({
    example: 5,
    description:
      'investorRemittanceRate, servicerRemittanceRate, and investor2RemittanceRate must add up to loan interest rate. ',
  }),
  investor2RemittanceRate: NonNegativeFloat.optional().meta({
    example: 1.5,
    description:
      'investorRemittanceRate, servicerRemittanceRate, and investor2RemittanceRate must add up to loan interest rate.',
  }),
  servicerRemittanceRate: NonNegativeFloat.optional().meta({
    example: 0.5,
    description:
      'investorRemittanceRate, servicerRemittanceRate, and investor2RemittanceRate must add up to loan interest rate.',
  }),
  investorOwnershipPercent: NonNegativePercentage.optional().meta({
    example: 50,
    description: 'The percentage of the loan that the investor owns.',
  }),
  investor2OwnershipPercent: NonNegativePercentage.optional().meta({
    example: 50,
    description: 'The percentage of the loan that the secondary investor owns.',
  }),
});
